import React, { useState, useEffect } from 'react';
import './UploadFile.scss';

const UploadFile = ({ paiement, setPaiement,formError,onFilesChange }) => {
    const [files, setFiles] = useState([]);
    const [isDragging, setIsDragging] = useState(false);
    const [error, setError] = useState('');
  
    const validTypes = ['application/pdf'];
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes
    const MAX_FILES = 1; // Maximum of files allowed

    // Drag and drop handlers
    const handleDragEnter = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(true);
    };
  
    const handleDragLeave = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);
    };
  
    const handleDragOver = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
  
    const validateFile = (file) => {
      if (!validTypes.includes(file.type)) {
        setError('Seuls les fichiers PDF sont autorisés');
        return false;
      }
       
      if (file.size > maxSize) {
        setError('La taille maximale du fichier est de 2MB');
        return false;
      }
      
      setError('');
      
      return true;
    };
  
    const updateFiles = (newFiles) => {
      // Filter out invalid files first
      
      const validFiles = newFiles.filter(file => {
        const isValid = validateFile(file);
        return isValid;
      });

      if (validFiles.length === 0) return;


      const formattedFiles = validFiles.map(file => ({
        name: file.name,
        size: `${ (file.size !== 0 && file.size) ? (file.size / (1024 * 1024)).toFixed(2)+" MB" : ''} `,
        progress: 0,
        type: file.type,
        fileObject: file
      }));
      const updatedFiles = [...files, ...formattedFiles];
      setFiles(updatedFiles);
      const dossierFiles = updatedFiles.map(f => f.fileObject);
      setPaiement(prev => ({
        ...prev,
        infovehicule: {
          ...prev.infovehicule,
          dossier: dossierFiles
        }
      }));
      onFilesChange(dossierFiles);
      simulateUploads(formattedFiles.length);
    };
   
    const handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);
      
      const droppedFiles = Array.from(e.dataTransfer.files)
        .filter(file => validTypes.includes(file.type));
      
      if (droppedFiles.length === 0) {
        setError('Seuls les fichiers PDF sont autorisés');
        return;
      }
  
      if (files.length + droppedFiles.length > MAX_FILES) {
        setError(`Vous ne pouvez uploader que ${MAX_FILES} fichier(s)`);
        return;
      }
  
      updateFiles(droppedFiles);
    };
  
    const handleFileInput = (e) => {
      const selectedFiles = Array.from(e.target.files)
        .filter(file => validTypes.includes(file.type));
      
      if (selectedFiles.length === 0) {
        setError('Seuls les fichiers PDF sont autorisés');
        return;
      }

      if (files.length + selectedFiles.length > MAX_FILES) {
        setError(`Vous ne pouvez uploader que ${MAX_FILES} fichier(s)`);
        return;
      }
  
      updateFiles(selectedFiles);
      e.target.value = '';
    };
  
    const simulateUploads = (newFilesCount) => {
      const startIndex = files.length;
      
      for (let i = 0; i < newFilesCount; i++) {
        const fileIndex = startIndex + i;
        simulateUpload(fileIndex);
      }
    };
  
    const simulateUpload = (fileIndex) => {
      let progress = 0;
      const interval = setInterval(() => {
        progress += Math.floor(Math.random() * 10) + 5;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        
        setFiles(prev => {
          const updatedFiles = [...prev];
          updatedFiles[fileIndex] = { ...updatedFiles[fileIndex], progress };
          return updatedFiles;
        });
      }, 300);
    };
  
    const removeFile = (index) => {
      const updatedFiles = files.filter((_, i) => i !== index);
      setFiles(updatedFiles);
      
      const dossierFiles = updatedFiles.map(f => f.fileObject);
      setPaiement(prev => ({
        ...prev,
        infovehicule: {
          ...prev.infovehicule,
          dossier: dossierFiles
        }
      }));
      
      // Notify form controller of change
      onFilesChange(dossierFiles);
    };

    useEffect(() => {
      if (paiement?.infovehicule?.dossier?.length > 0) {
        const initialFiles = paiement.infovehicule.dossier.map(file => ({
            name: file.name,
            size: `${(file.size / (1024 * 1024)).toFixed(2)} MB`,
            progress: 100,
            type: file.type,
            fileObject: file
        }));
        setFiles(initialFiles);
    }
    }, []);
    return (
      <div className="upload-file">  
        <div 
          className={`drop-zone ${isDragging ? 'dragging' : ''} ${files.length >= MAX_FILES ? 'disabled' : ''}`}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <input 
            type="file" 
            id="file-upload" 
            multiple 
            accept=".pdf,application/pdf"
            onChange={handleFileInput}
            style={{ display: 'none' }}
            disabled={files.length >= MAX_FILES}
          />
          <label htmlFor="file-upload" className="drop-zone-label">
            <div className="upload-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M17 8L12 3L7 8" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 3V15" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Cliquez pour uploader ou glisser-déposer</h3>
            <p>Formats acceptés: PDF (Max. 2 MB)</p>
          </label>
        </div>
        
        {error && <div className="error-message">{error}</div>}
        
        <div className="file-list">
          {files.map((file, index) => (
            <div key={index} className="file-item">
              <div className="file-info">
                <div className="file-preview">
                  <div className="pdf-preview">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M14 2V8H20" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M16 13H8" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M16 17H8" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M10 9H9H8" stroke="#4F46E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
                <div className="file-details">
                  <span className="file-name">{file?.name || ""}</span>
                  <span className="file-size">{file?.size !== 'NaN MB' ? file?.size : ""}</span>
                </div>
              </div>
              <div className="file-progress">
                {file.progress === 100 ? (
                  <button className="remove-btn" onClick={() => removeFile(index)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M6 6L18 18" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                ) : (
                  <div className="progress-text">{file.progress}%</div>
                )}
                <div className="progress-bar">
                  <div 
                    className="progress-fill" 
                    style={{ width: `${file.progress}%`, backgroundColor: file.progress === 100 ? '#10B981' : '#4F46E5' }}
                  ></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
};

export default UploadFile;